import React from 'react'
import { Box } from '@mui/material'
import { makeStyles } from '@material-ui/core/styles'

const BikeAnimation = () => {
  const classes = useStyles()
  return (
    <Box>
      <Box className={classes.bikeAnimationSection}>
        <iframe
          src='https://paisaplan.s3.ap-south-1.amazonaws.com/public/animations/buyPolicy/motor/twowheeler/data.html'
          frameBorder='0'
          allowFullScreen
          className={classes.bikeAnimationContainer}
        />
      </Box>
    </Box>
  )
}

export default BikeAnimation

const useStyles = makeStyles({
  bikeAnimationSection: {
    zIndex: 1,
    width: '100%',
    marginTop: '-8%',
    '@media (min-width: 1460px)': {
      marginTop: '-3%',
    },
    background: '#FFFFFF',
  },

  bikeAnimationContainer: {
    height: '360px',
    width: '100%',
  },
})
